<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="modal-container" @click.stop>
					<div class="modal-header">
						<h3 class="modal-title">Check SJ, Unit & Rute</h3>
						<button type="button" class="close" @click="$emit('closeModal')">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div class="modal-body">
						<div class="wrapper">
							<div v-if="dataTable && propData">
								<!-- NO TO & NOPOL Section -->
								<div class="row text-left">
									<div class="col-6">
										<h3 class="stats-label">NO TO</h3>
										<h3 class="stats-label">NOPOL</h3>
									</div>
									<div class="col-6">
										<h3 class="stats-value">: {{ data.no_to }}</h3>
										<h3 class="stats-value">: {{ data.nopol }}</h3>
									</div>
								</div>

								<!-- SJ & Unit Section -->
								<div class="row text-left mt-2">
									<div class="col-6">
										<h3 class="stats-label">Total SJ</h3>
										<h3 class="stats-label">Jumlah Unit</h3>
										<h3 class="stats-label">Total SJ Supir</h3>
										<h3 class="stats-label">Total Unit Supir</h3>
									</div>
									<div class="col-6">
										<h3 class="stats-value">: {{ dataTable.total_sj }}</h3>
										<h3 class="stats-value">: {{ dataTable.total_coly }}</h3>
										<h3 class="stats-value">: {{ dataTable.driver_sj }}/{{ dataTable.total_sj }}</h3>
										<h3 class="stats-value">: {{ dataTable.driver_coly }}/{{ dataTable.total_coly }}</h3>
									</div>
								</div>

								<div class="divider mt-4 mb-4"></div>

								<!-- Route Section -->
								<div class="route-section" v-if="propData.child && propData.child.length > 0">
									<div class="rute-card d-flex" v-for="dat in propData.child" v-bind:key="dat.no_to">
										<div class="col-2 d-flex align-items-center justify-item-center">
											<div class="rute-urutan-box">
												<p v-if="dat.nomor != 0">
													{{ zeroPad(dat.nomor, 2) }}
												</p>
												<p v-else>
													<i class="fas fa-question" style="color: grey"></i>
												</p>
											</div>
											<div class="text-center">
												<p class="dealer--distance text-center">
													+/-
													<span class="ml-2">{{ dat.distance }}Km</span>
												</p>
											</div>
										</div>
										<div class="col-7 pl-2">
											<p class="dealer-list-title dealer--name text-left">{{ dat.kd_dealer }}</p>
											<p class="dealer--address text-left">{{ dat.address }}</p>
										</div>
										<div class="col-3">
											<div class="mb-2">
												<p class="dealer-list-title dealer--distance text-center">Kode Dealer</p>
											</div>
											<div>
												<p class="dealer--distance text-center">
													{{ dat.dealer_code }}
												</p>
											</div>
										</div>
									</div>
								</div>
								<div style="min-height: 200px; display: flex; align-items: center; justify-content: center" v-else>
									<p style="margin: 0; font-size: 24px; text-shadow: 2px 2px 2px grey">No Route Data</p>
								</div>

								<!-- Action Buttons -->
								<div class="row" style="margin-top: 50px">
									<div class="col-md-6" style="display: flex; justify-content: center">
										<button
											class="btn simple--button mt-3"
											type="button"
											@click="handleReject"
											style="font: normal normal normal 20px/30px Poppins"
											:disabled="dataTable.status !== 0"
										>
											Tolak
										</button>
									</div>
									<div class="col-md-6" style="display: flex; justify-content: center">
										<button
											class="btn simple--button mt-3"
											type="button"
											@click="handleApprove"
											style="font: normal normal normal 20px/30px Poppins; color: white; background-color: #1b698e"
											:disabled="dataTable.status !== 0"
										>
											Setuju
										</button>
									</div>
								</div>
							</div>
							<div class="text-center pt-5 pb-5" v-else>
								<h1>Loading...</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			propData: null,
			dataTable: null,
		}
	},
	props: ['data'],
	mounted() {
		// Use combined API endpoint for better performance
		this.loadDocumentDetailsWithRoute()
	},
	methods: {
		zeroPad(num, places) {
			return String(num).padStart(places, '0')
		},

		async loadDocumentDetailsWithRoute() {
			try {
				let url = `/api/validation/document-detail-with-rute?no_to=${this.data.no_to}&nopol=${this.data.nopol}`
				let resp = await this.$http.get(url)
				const data = resp.data.data

				// Set dataTable with the main document details
				this.dataTable = {
					total_sj: data.total_sj,
					total_coly: data.total_coly,
					driver_sj: data.driver_sj,
					driver_coly: data.driver_coly,
					status: data.status_sj,
				}

				// Set propData with the route information
				this.propData = {
					child: data.routes || [],
				}

				console.log('Document details loaded:', this.dataTable)
				console.log('Route data loaded:', this.propData)
			} catch (err) {
				console.log('Error loading document details:', err)
			}
		},

		async loadToDetails() {
			try {
				let url = `/api/validation/to-detail?no_to=${this.data.no_to}&nopol=${this.data.nopol}`
				let resp = await this.$http.get(url)
				this.dataTable = resp.data.data[0]
			} catch (err) {
				console.log(err)
			}
		},

		loadRouteData() {
			this.$http
				.get(`/api/validation/rute-ekspedisi?no_to=${this.data.no_to}&nopol=${this.data.nopol}`)
				.then((resp) => {
					this.propData = resp.data.data
					console.log(this.propData)
				})
				.catch((err) => {
					console.log(err)
				})
		},

		handleApprove() {
			this.$http
				.put('/api/validation/update-to-and-rute', {
					no_to: this.data.no_to,
					nopol: this.data.nopol,
					sj_status: 1,
					rute_status: 1,
					insert_id: Number(this.data.rute_id),
				})
				.then(() => {
					this.$swal.fire({
						title: 'Sukses!',
						text: 'Pengecekan berhasil di setujui.',
						icon: 'success',
					})
					this.$emit('refreshTable')
					this.$emit('closeModal')
				})
				.catch((err) => {
					console.log(err)
					this.$swal.fire({
						title: 'Error!',
						text: 'Terjadi kesalahan saat menyetujui pengecekan.',
						icon: 'error',
					})
				})
		},

		handleReject() {
			this.$http
				.put('/api/validation/update-to-and-rute', {
					no_to: this.data.no_to,
					nopol: this.data.nopol,
					sj_status: 2,
					rute_status: 2,
					insert_id: Number(this.data.rute_id),
				})
				.then(() => {
					this.$swal.fire({
						title: 'Sukses!',
						text: 'Pengecekan berhasil di tolak.',
						icon: 'success',
					})
					this.$emit('refreshTable')
					this.$emit('closeModal')
				})
				.catch((err) => {
					console.log(err)
					this.$swal.fire({
						title: 'Error!',
						text: 'Terjadi kesalahan saat menolak pengecekan.',
						icon: 'error',
					})
				})
		},
	},
}
</script>

<style scoped>
.modal-mask {
	position: fixed;
	z-index: 1020;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.modal-container {
	width: 50%;
	background-color: #fff;
	border-radius: 8px;
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: #ffffff;
	padding: 20px 24px;
	border-bottom: 1px solid #e0e0e0;
}

.modal-header .modal-title {
	margin: 0;
	font: normal normal normal 20px/30px Poppins;
	color: #333333;
	font-weight: 500;
}

.modal-header .close {
	margin: 0;
	font-size: 2rem;
	font-weight: 400;
	background: none;
	border: none;
	cursor: pointer;
}

.modal-body {
	padding: 0;
	max-height: 80vh;
	overflow-y: auto;
	overflow-x: auto;
}

.modal-body .wrapper {
	padding: 32px;
}

.info-section {
	margin-bottom: 20px;
}

.info-row {
	display: flex;
	margin-bottom: 10px;
	font: normal normal normal 18px/27px Poppins;
}

.info-label {
	min-width: 120px;
	color: #333333;
}

.info-separator {
	margin: 0 10px;
	color: #333333;
}

.info-value {
	color: #333333;
	word-wrap: break-word;
}

.stats-label {
	font: normal normal normal 18px/30px Poppins;
	color: #333333;
	margin-bottom: 8px;
}

.stats-value {
	font: normal normal normal 18px/30px Poppins;
	color: #333333;
	margin-bottom: 8px;
}

.divider {
	width: 100%;
	height: 2px;
	background-color: #e0e0e0;
}

.route-section {
	max-height: 400px;
	overflow-y: auto;
}

.rute-card {
	background: #ffffff 0% 0% no-repeat padding-box;
	padding: 20px 0;
	border-bottom: 1px solid #f0f0f0;
}

.rute-card:last-child {
	border-bottom: none;
}

.rute-card > div {
	display: flex;
	flex-direction: column;
	padding: 0;
}

.rute-card .rute-urutan-box {
	border: 5px solid #f77070;
	border-radius: 200px;
	height: 50px;
	width: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.rute-card .rute-urutan-box p {
	font: normal normal normal 16px/18px Poppins;
	font-weight: bold;
	margin: 0;
}

.rute-card .dealer-list-title {
	font: normal normal 500 18px/20px Poppins;
	margin-bottom: 10px;
	color: #606060;
}

.rute-card .dealer--address {
	font: normal normal 500 14px/16px Poppins;
	margin: 0;
	color: #606060;
}

.rute-card .dealer--distance {
	font: normal normal 500 14px/16px Poppins;
	margin: 0;
	color: #606060;
}

.simple--button {
	width: 100%;
	box-shadow: 0px 0px 6px #00000029;
	border: 1px solid #000000;
	border-radius: 8px;
	padding: 12px 20px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.simple--button:hover:not(:disabled) {
	background-color: #f5f5f5;
}

.simple--button:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>
